import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  ColorPickerComponent,
  DatePickerComponent,
  FormBooleanSelectComponent,
  FormBtnComponent,
  FormImportFileComponent,
  FormInputComponent,
  FormInputPasswordConfirmPasswordComponent,
  FormMultipleDatepickerComponent,
  FormMultiSelectComponent,
  FormPrestationTypeSelectComponent,
  FormSelectComponent,
  TimePickerComponent
} from '@shared/module/forms/component';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SerenityPipeModule} from '@pipe';
import {FormCheckComponent} from '@shared/module/forms/component/form-check/form-check.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';
import {MatIconModule} from '@angular/material/icon';
import {ColorPickerModule} from 'ngx-color-picker';
import {SwitchComponent} from './component/switch/switch.component';
import {SerenityDirectiveModule} from '@directive';
import {MatSelectModule} from '@angular/material/select';
import {MatCardModule} from '@angular/material/card';
import {MatDividerModule} from '@angular/material/divider';
import {DialogModule} from '@dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatButtonModule} from "@angular/material/button";
import {MatChipsModule} from "@angular/material/chips";


@NgModule({
  declarations: [
    FormBooleanSelectComponent,
    FormBtnComponent,
    FormInputComponent,
    FormSelectComponent,
    FormMultiSelectComponent,
    FormSelectComponent,
    FormPrestationTypeSelectComponent,
    FormCheckComponent,
    ColorPickerComponent,
    DatePickerComponent,
    TimePickerComponent,
    SwitchComponent,
    FormInputPasswordConfirmPasswordComponent,
    FormImportFileComponent,
    FormMultipleDatepickerComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    SerenityPipeModule,
    MatCheckboxModule,
    NgxMaterialTimepickerModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatIconModule,
    ColorPickerModule,
    MatCheckboxModule,
    SerenityDirectiveModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatCardModule,
    MatDividerModule,
    DialogModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatChipsModule,
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'fr-FR'},
  ],
  exports: [
    FormBooleanSelectComponent,
    FormBtnComponent,
    FormInputComponent,
    FormSelectComponent,
    FormMultiSelectComponent,
    FormSelectComponent,
    FormPrestationTypeSelectComponent,
    FormCheckComponent,
    ColorPickerComponent,
    DatePickerComponent,
    TimePickerComponent,
    SwitchComponent,
    FormInputPasswordConfirmPasswordComponent,
    FormImportFileComponent,
    FormMultipleDatepickerComponent
  ],
})
export class SerenityFormsModule {
}
